/* eslint-disable no-console */
export class Logger {
  static log = (...args: unknown[]): void => {
    if (import.meta.env.VITE_PUBLIC_URL === 'https://fullglass.ai') {
      return;
    }

    console.log(...args);
  };

  static error = (...args: unknown[]): void => {
    console.error(...args);
  };

  static warn = (...args: unknown[]): void => {
    if (import.meta.env.VITE_PUBLIC_URL === 'https://fullglass.ai') {
      return;
    }

    console.warn(...args);
  };
}
